import styled from 'styled-components';
import { Ul } from '~/components/typography';

export const HelpIconWrapper = styled.div`
  &.hide {
    display: none;
  }
`;

export const SubtitleList = styled(Ul)`
  li {
    font-size: 12px;
  }

  li:not(:last-child) {
    margin-bottom: 8px;
  }
`;
